import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { format } from 'date-fns';
import ToPeso from '../misc/ToPeso';

function PublicHeaderLoan({ loan }) {
    if (!loan) return null;

    // Calculate loan status based on payments and dates
    const calculateStatus = () => {
        if (loan.is_paid) return 'paid';
        
        const today = new Date();
        const dueDate = new Date(loan.dateGranted);
        dueDate.setMonth(dueDate.getMonth() + (parseInt(loan.loanTerm) * 31));
        
        if (today > dueDate) return 'past due';
        return 'current';
    };

    const status = calculateStatus();
    const statusClass = status.toLowerCase();

    // Get full name from applicant object
    const getFullName = () => {
        if (!loan.applicant) return 'N/A';
        const { firstName, middleName, lastName } = loan.applicant;
        return `${firstName} ${middleName} ${lastName}`.trim();
    };

    return (
        <div className="public-header-loan">
            <Container>
                <Row className="header-content">
                    <Col lg={8} className="header-main">
                        <div className="header-title">
                            <h1>Loan Details</h1>
                            <div className="loan-status">
                                <span className={`status-badge ${statusClass}`}>
                                    {status.toUpperCase()}
                                </span>
                            </div>
                        </div>
                        <div className="header-info">
                            <div className="info-group">
                                <div className="info-label">Applicant Name</div>
                                <div className="info-value">{getFullName()}</div>
                            </div>
                            <div className="info-group">
                                <div className="info-label">Contact Number</div>
                                <div className="info-value">{loan.applicant?.mobileNo1 || 'N/A'}</div>
                            </div>
                            <div className="info-group">
                                <div className="info-label">Email Address</div>
                                <div className="info-value">{loan.applicant?.emailAddress || 'N/A'}</div>
                            </div>
                            <div className="info-group">
                                <div className="info-label">Loan ID</div>
                                <div className="info-value">#{loan.id || 'N/A'}</div>
                            </div>
                            <div className="info-group">
                                <div className="info-label">Date Granted</div>
                                <div className="info-value">
                                    {loan.dateGranted ? format(new Date(loan.dateGranted), 'MMMM dd, yyyy') : 'N/A'}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4} className="header-summary">
                        <div className="summary-card">
                            <div className="summary-title">Loan Amount</div>
                            <div className="summary-value">
                                <ToPeso amount={loan.amountGranted || 0} />
                            </div>
                        </div>
                        <div className="summary-card">
                            <div className="summary-title">Interest Rate</div>
                            <div className="summary-value">{loan.interestRate ? `${loan.interestRate}%` : 'N/A'}</div>
                        </div>
                        <div className="summary-card">
                            <div className="summary-title">Loan Term</div>
                            <div className="summary-value">{loan.loanTerm ? `${loan.loanTerm} months` : 'N/A'}</div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default PublicHeaderLoan; 